const PROJECT = {
  writersShortlist: { maxLength: 20 },
  wordCountPercentageLimit: { min: 90, max: 110 },
};

export default PROJECT;
